import axios from "axios";

export default {
   namespaced: true,
   state: {
      items: [],
      items_meta: []
   },
   mutations: {
      SET_ITEMS(state, items) {
         state.items = items.data;
         state.items_meta = items.meta;
      }
   },
   actions: {
      getItems({ commit }, payload) {
         let params = {};
            let config = {};
         if (payload !== null && payload !== undefined) {

            if (payload.page !== null && payload.page !== undefined) {
               params["page"] = payload.page;
            }
            if (payload.per_page !== null && payload.per_page !== undefined) {
               params["per_page"] = payload.per_page;
            }
            if (payload.search_value !== null && payload.search_value !== undefined) {
               params["search_value"] = payload.search_value;
            }
            if (payload.all !== null && payload.all !== undefined) {
               params["all"] = payload.all;
            }
            if (payload.for_user_list !== null && payload.for_user_list !== undefined) {
               params["for_user_list"] = payload.for_user_list;
            }
            if (payload.include_custom !== null && payload.include_custom !== undefined) {
               params["include_custom"] = payload.include_custom;
            }
            if (payload.only_in_stock !== null && payload.only_in_stock !== undefined) {
               params["only_in_stock"] = payload.only_in_stock;
            }
            if (payload.user_id !== null && payload.user_id !== undefined) {
               params["user_id"] = payload.user_id;
            }
               if (payload.showLoader !== null && payload.showLoader !== undefined) {
                  config.showLoader = payload.showLoader;
               }
         }
            return axios.get(`items`, { 
               params: new URLSearchParams(params),
               ...config
            })
           .then(response => {
              commit("SET_ITEMS", response.data);
                 return response;
           });
      }
   }
};
